export const getPopupData = (url: string) =>
  fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((response: Response) => response.text())
    .then((text: string) => {
      const parser = new DOMParser();
      return parser.parseFromString(text, 'text/html');
    })
    .catch((err: Error) => console.warn('Something went wrong:', err));
